var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{attrs:{"gutter":8}},[_c('Col',{attrs:{"span":24}},[_c('subject-consist')],1),_c('Col',{staticStyle:{"padding-top":"20px"},attrs:{"span":24}},[_c('div',{attrs:{"id":"subjectStat"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }